import React from 'react';
import EvaluateChapterItem from './EvaluateChapterItem';
import { EvaluateElement } from '../../types/EvaluateElement';

interface EvaluateChapterListProps {
    chapters: EvaluateElement[];
}

const EvaluateChapterList: React.FC<EvaluateChapterListProps> = ({
    chapters,
}) => {
    return (
        <div className="mt-4">
            {chapters.map(
                (chapter, index) =>
                    chapter.title && (
                        <div key={index}>
                            <EvaluateChapterItem chapter={chapter} />
                            {index !== chapters.length - 1 && (
                                <hr className="border-gray-400  border-1 opacity-50 border-dashed" />
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default EvaluateChapterList;
